import { Tag } from "antd"
import PropTypes from "prop-types"
import { colors } from "themes/variables"

const selectedColor = {
  "Booking Request": colors.warning,
  Upcoming: colors.sportsmanBrand,
  Canceled: colors.error,
  Completed: colors.success,
  Paid: colors.success,
  Unpaid: colors.yellow,
  "Payment Outstanding": colors.warning,
  "Partially Refunded": colors.success,
  Refunded: colors.sportsmanBrand,
  Failed: colors.error,
  failed: colors.error, // will update soon lower and upper
  pending: colors.warning,
  processing: colors.sportsmanBrand,
  partial_completed: colors.warning,
  skipped_failed: colors.warning,
  completed: colors.success
}

/**
 * Determines the color for a status badge based on both payment status and booking status
 * Implements business logic where certain payment statuses should be red for cancelled bookings
 *
 * @param {string} status - The status to display (e.g., "Partially Refunded", "Refunded")
 * @param {string} bookingStatus - The booking status (e.g., "Canceled", "Completed", "Upcoming")
 * @returns {string} The color hex code from theme variables
 */
const getStatusColor = (status, bookingStatus) => {
  const normalizedBookingStatus = bookingStatus?.toLowerCase()
  const isCanceled = normalizedBookingStatus === "canceled" || normalizedBookingStatus === "cancelled"

  // For cancelled bookings, refund statuses and payment outstanding should be red
  if (isCanceled) {
    if (status === "Refunded" || status === "Partially Refunded" || status === "partial_refund" || status === "Payment Outstanding") {
      return colors.error // Red for refunded/partially refunded/outstanding cancelled bookings
    }
  }

  return selectedColor[status] || colors.textSecondary
}

const StatusTag = ({ status, statusMessage, bookingStatus }) => {
  const color = getStatusColor(status, bookingStatus)

  return (
    <Tag
      title={status}
      className={`px-s mr-0 py-xxs border-0`}
      style={{
        maxWidth: "fit-content",
        color: color,
        backgroundColor: color + "30"
      }}
    >
      {statusMessage ?? status}
    </Tag>
  )
}

StatusTag.propTypes = {
  status: PropTypes.string,
  statusMessage: PropTypes.string,
  bookingStatus: PropTypes.string
}

export default StatusTag
